import { createFileRoute } from "@tanstack/react-router";
import { Box, Paper } from "@mui/material";
import { useAuth } from "../../auth";
// @ts-ignore — JSX module from modeler workspace package
import { ModelerView } from "@smartdocs/modeler/modeler";

export const Route = createFileRoute("/__auth/modeler")({
    component: ModelerComponent,
    staticData: {
        title: "routes.designAutomation",
    },
});

function ModelerComponent() {
    const { currentTenant, user } = useAuth();

    const tokenStr = localStorage.getItem("token") || sessionStorage.getItem("token");
    const tokenData = tokenStr ? JSON.parse(tokenStr) : null;
    const accessToken = tokenData?.accessToken || "";

    return (
        <Box sx={{ height: "calc(100vh - 100px)", width: "100%", p: 2 }}>
            <Paper
                elevation={0}
                variant="outlined"
                sx={{
                    height: "100%",
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: 2
                }}
            >
                <ModelerView
                    setup={{
                        uploadFileUrl: `${window.location.origin}/api/smartbpm/smart-bpm/rest/attachment/new`,
                        getDocumentUrl: `${window.location.origin}/api/documentos/files/{fileUid}/generate-temporary-link`,
                        email: user?.email,
                        tenant: currentTenant || user?.tenant,
                        baseUrl: window.location.origin,
                        token: accessToken,
                        dataListUrl: `${window.location.origin}/api/smartbpm/v1/{tenant}/data-list/{dataListId}/items/all`,
                        previewMode: false,
                        user,
                    }}
                />
            </Paper>
        </Box>
    );
}
